import React from "react";
import DataGridComponent from "../components/tables/DataGrid";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import useDataGrid from "../hooks/useDataGrid";
import BreadCrumb from "../components/BreadCrumb/BreadCrumb";
import ServicesUpdate from "../components/modal/ServicesUpdate";
import { deleteRiesgo, getAllRiesgo } from "../redux/slices/riesgo";
import RiesgoUpdate from "../components/modal/RiesgoUpdate";

const permitedRenderDataColumn = [
  { title: "ID", value: "id", hide: true },
  { title: "Nombre", value: "name" },
  { title: "Desde (Menor)", value: "desde" },
  { title: "Hasta (Mayor)", value: "hasta" },
  { title: "Acciones", value: "acciones_inv" },
];

export default function Riesgo() {
  const { riesgo, success } = useSelector((state) => state.riesgo);
  const [open, setOpen] = useState({
    status: false,
    data: null,
  });
  const dispatch = useDispatch();

  const handleDelete = async (params) => {
    const id = params.id;
    await dispatch(deleteRiesgo(id));
    setOpen({ status: false, data: null });
  };

  const [columns] = useDataGrid(permitedRenderDataColumn, handleDelete, "SERVICIO", false, setOpen);

  useEffect(() => {
    dispatch(getAllRiesgo());
  }, [dispatch]);

  return (
    <div>
      <div className="flex justify-between my-2 items-center bg-[#2b2c84]/20 px-5 py-2 rounded">
        <div>
          <h1 className="font-semibold text-[#1E293B] text-2xl">Riesgo</h1>
          <BreadCrumb origin={"Mantenedores"} current={"Riesgo"} />
        </div>
        <div>
          <RiesgoUpdate open={open.status} data={open.data} setOpen={setOpen} />
        </div>
      </div>
      <DataGridComponent columns={columns} rows={riesgo} success={success} />
    </div>
  );
}
